import { MAX_VOTES } from '../ZodiacClashHelpers';
import { useTranslation } from 'react-i18next';
import { localizedServerContent } from '../../../localization/presentationLanguage';

export default function ClashEmptyState({
  styles,
  locked,
  completedCountdown,
  day,
}) {
  const { t } = useTranslation('zodiacClash');
  const profile = day?.profile || null;

  const currentStreak = Number(
    day?.currentStreak ??
    profile?.currentStreak ??
    0
  );

  const bestStreak = Number(
    day?.bestStreak ??
    profile?.bestStreak ??
    0
  );

  const totalDecisions = Number(
    profile?.totalVotes ??
    profile?.decisions ??
    day?.myVotes ??
    0
  );

  const topSigns = Array.isArray(profile?.topSigns)
    ? profile.topSigns
    : [];

  const affinities = topSigns
    .map((item) => item?.label)
    .filter(Boolean)
    .slice(0, 2);

  const profileTitle = localizedServerContent(profile?.title, t('formingProfile'));

  const profileSubtitle = localizedServerContent(profile?.subtitle, t('profilePartOfDominion'));

  return (
    <section style={styles.noClashSection}>
      <div style={styles.noClashMessage}>
        {locked
          ? t('completedToday')
          : t('noDuel')}
      </div>

      {locked && (
        <div
          className="zdxClashSummary"
          style={styles.clashSummaryCard}
          aria-live="polite"
        >
          <div style={styles.clashSummaryEyebrow}>
            ✨ {t('clashComplete')}
          </div>

          <div style={styles.clashSummaryTitle}>
            {profileTitle}
          </div>

          <div style={styles.clashSummaryText}>
            {profileSubtitle}
          </div>

          <div
            className="zdxClashSummaryGrid"
            style={styles.clashSummaryGrid}
          >
            <div style={styles.clashSummaryStat}>
              <span style={styles.clashSummaryStatLabel}>
                {t('currentStreak')}
              </span>
              <strong style={styles.clashSummaryStatValue}>
                🔥 {currentStreak}
              </strong>
            </div>

            <div style={styles.clashSummaryStat}>
              <span style={styles.clashSummaryStatLabel}>
                {t('bestStreak')}
              </span>
              <strong style={styles.clashSummaryStatValue}>
                {bestStreak}
              </strong>
            </div>

            <div style={styles.clashSummaryStat}>
              <span style={styles.clashSummaryStatLabel}>
                {t('decisions')}
              </span>
              <strong style={styles.clashSummaryStatValue}>
                {totalDecisions}
              </strong>
            </div>
          </div>

          {affinities.length > 0 && (
            <div style={styles.clashSummaryAffinity}>
              {t('currentAffinity')}: {affinities.join(` ${t('and')} `)}
            </div>
          )}

          <div style={styles.clashSummaryCountdown}>
            <span aria-hidden="true">⏳</span>
            {t('newClashIn', { countdown: completedCountdown })}
          </div>
        </div>
      )}

      {!locked && (
        <div style={styles.clashSummaryCountdown}>
          {t('newMatchups')}
        </div>
      )}

      {Array.isArray(day?.results) && day.results.length > 0 && (
        <div style={styles.resultsContainer} aria-live="polite">
          <h2 style={styles.resultsTitle}>
            📊 {t('todaysResults')}
          </h2>

          {day.results.map((result, index) => (
            <div key={index} style={styles.resultRow}>
              <span style={styles.resultSign}>{result.a}</span>
              <span style={styles.resultVs}>vs</span>
              <span style={styles.resultSign}>{result.b}</span>
              <span style={styles.resultPercent}>
                {result.percentA}% / {result.percentB}%
              </span>
            </div>
          ))}
        </div>
      )}

      {locked && (
        <div
          style={{
            marginTop: 14,
            fontSize: 12,
            fontWeight: 800,
            color: 'rgba(255,233,166,0.66)',
          }}
        >
          {t('clashesCompletedToday', { completed: MAX_VOTES, total: MAX_VOTES })}
        </div>
      )}
    </section>
  );
}
